<template>
  <section class="trend-content">
    <div class="main">
      <div class="first">
        &lt;<span>{{trend_main_title_}}</span>&gt;
      </div>
      <div class="second">
        <highcharts :options="options"></highcharts>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import Highcharts from 'highcharts'

  import { trend } from '@/utils/api.js'
  import { getServerNow } from '@/utils/index'

  import i18n from '@/i18n'
  import bus from '@/utils/event_bus.js'

  Highcharts.setOptions({
    global: {
      useUTC: false
    }
  })

  export default {
    data () {
      return {
        result: [],
        options: {
          credits: {
            enabled: false
          },
          chart: {
            type: 'spline',
            backgroundColor: '#212121'
          },
          title: {
            text: '',
            style: {
              color: '#FFF'
            },
            x: -20
          }
        }
      }
    },
    computed: {
      ...mapState(['startTime', 'endTime', 'timeDelta', 'trendTeamNum', 'v_locale']),
      ...mapGetters([]),
      ...i18n.map(['trend_main_title_'])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      init () {
        const top10teams = []
        const top10scores = []

        trend()
          .then((data) => {
            if (!data.data) {
              return
            }
            const chartStartAt = this.startTime.toDate()
            const end = this.endTime
            const trenddata = []
            const now = getServerNow()
            data.data.some((dt, teamidx) => {
              const tmpdt = []
              let curscore = 0
              tmpdt.push({
                x: +chartStartAt,
                y: 0
              })
              dt.solved.forEach((dtdt, challengeidx) => {
                if (dtdt.score <= 0) {
                  tmpdt.push({
                    x: dtdt.timestamp * 1000,
                    y: curscore += dtdt.score
                  })
                } else {
                  tmpdt.push({
                    x: dtdt.timestamp * 1000,
                    y: curscore += dtdt.score,
                    solved_problem: `(${dtdt.title}  +${dtdt.score})`,
                    marker: {
                      enabled: true
                    }
                  })
                }
              })
              tmpdt.push({
                x: now > end ? +end : +now,
                y: tmpdt[tmpdt.length - 1]['y'],
                marker: {
                  enabled: false
                }
              })
              top10teams.push(dt.tid)
              top10scores.push(tmpdt[tmpdt.length - 1]['y'])
              const trendseries = {
                name: dt.name,
                data: tmpdt
              }
              trenddata.push(trendseries)
              if (trenddata.length >= this.trendTeamNum) {
                return true
              }
            })
            this.options = {
              credits: {
                enabled: false
              },
              colors: ['#00FA9A', '#FFD700', '#FF1493', '#FF8C00', '#9932CC', '#32CD32', '#1E90FF', '#228B22', '#AFEEEE', '#FA8072'],
              chart: {
                type: 'spline',
                backgroundColor: 'transparent'
              },
              title: {
                text: '',
                style: {
                  color: '#FFF'
                },
                x: -20
              },
              tooltip: {
                pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.y}</b>{point.solved_problem}<br/>'
              },
              xAxis: {
                type: 'datetime',
                title: {
                  text: 'Time'
                },
                dateTimeLabelFormats: {
                  month: '%e. %b',
                  year: '%b'
                }
              },
              yAxis: {
                title: {
                  text: 'Score'
                },
                plotLines: [{
                  value: 0,
                  width: 1,
                  color: '#808080'
                }],
                min: 0
              },
              legend: {
                align: 'center',
                verticalAlign: 'bottom',
                itemStyle: {
                  color: '#53a5ff',
                  fontSize: '14px'
                },
                itemHoverStyle: {
                  color: '#fff'
                },
                margin: 2,
                borderWidth: 0
              },
              series: trenddata
            }
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      }
    },
    created () {
      this.init()
      bus.$on('UPDATE', this.init)
    },
    beforeDestroy () {
      bus.$off('UPDATE', this.init)
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/themes/dragon/components/trend.vue